/**
 * Get environment-specific cookie name suffix based on the current domain
 * 
 * @returns {string} Cookie name suffix: '-localdevelopment', '-cloudstage', or '' (no suffix for production)
 */
export const getCookieSuffix = () => {
    
  if (typeof window === 'undefined') return '';

  const host = window.location.host.toLowerCase();
  const url = window.location.href.toLowerCase();
  
  switch (true) {
    case host.includes('localhost') || host.includes('housing-local.id.com.au'):
      return '-localdevelopment';
    
    case host.includes('housing-dev.id.com.au') || url.includes('angry'):
      return '-clouddevelopment';
    
    case host.includes('housing-stg.id.com.au') || host.includes('dev.housing.id.com.au'):
      return '-cloudstage';
    
    default:
      // Production: no suffix
      return '';
  }
};

/**
 * Get environment-specific cookie names based on the current domain
 * 
 * @returns {Object} Object with fasid and fahousing cookie names
 */
export const getCookieNames = () => {
  const suffix = getCookieSuffix();
  
  return {
    fasid: `fasid${suffix}`,
    fahousing: `fahousing${suffix}`
  };
};

/**
 * Get cookie value by name
 * @param {string} name - Cookie name
 * @returns {string|null} Cookie value or null
 */
export const getCookie = (name) => {
  if (typeof window === 'undefined') return null
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
  return null
}

/**
 * Extract alias from pathname.
 * Alias is the first path segment (e.g., "/gold-coast/..." -> "gold-coast").
 * @param {string} pathname - The pathname to extract alias from
 * @returns {string|null} The alias or null if not found
 */
export const getAliasFromPathname = (pathname) => {
  const segments = pathname.split('/').filter(Boolean);
  return segments.length > 0 ? segments[0] : null;
}

